// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__dM7Yf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__UmXUu"};